// extracted by mini-css-extract-plugin
export var pillWrapper = "_og-0";
export var showOverflow = "_og-1";